import { Listener } from '../listenersStore';

const applicationsListeners: Listener = {
  'refresh/applications': (dispatch: any, action: any) => {
    const {
      payload: { projectId },
    } = action;
    dispatch({
      type: 'FETCH_PROJECT_START',
      payload: { variables: { id: projectId }, recache: true },
    });
  },
};

export default applicationsListeners;
